module.exports = __webpack_public_path__ + "images/sd2-01-desktop.png";